var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2258 3c1.74182 0 3.17568 1.3758 3.26933 3.09515l.00487.17904V23.1129c0 1.74182-1.3758 3.17568-3.09515 3.26933l-.17904.00487H3.77419c-1.7418 0-3.17567-1.3758-3.26932-3.09515L.5 23.1129V6.2742c0-1.74182 1.3758-3.17568 3.09515-3.26933L3.77419 3h22.45162zm2.33872 4.17132l-13.29629 9.30864c-.13804.09664-.31525.11044-.46449.04142l-.07197-.04142-13.29629-9.3077V23.1129c0 1.23382.9709 2.25406 2.18565 2.3337l.15306.00501h22.45162c1.2338 0 2.25406-.9709 2.3337-2.18565l.005-.15306V7.17132zM26.2258 3.93548H3.77419c-1.20603 0-2.208.92767-2.3269 2.10398L15 15.52519l13.55271-9.48573c-.11373-1.12517-1.03541-2.02284-2.1708-2.09877l-.1561-.0052z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3680835e.svg";
export { ForwardRef as ReactComponent };